export function takeResponseErrors(errors = {}) {
  for (const key in errors) {
    if (errors.hasOwnProperty(key) && Array.isArray(errors[key]) && errors[key].length > 0) {
      return errors[key][0];
    }
  }
  return null;
}
